import { Component } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { Heading } from "./Typoraphy";

class List extends Component {
  static Item = ({ children, style, ...props }) => (
    <li css={{ cursor: "pointer", ...style }} {...props}>
      {children}
    </li>
  );

  render() {
    const { heading, children, style } = this.props;
    return (
      <ul css={{ listStyle: "none", ...style }}>
        {heading && (
          <Heading level={heading.level || 3} style={heading.style}>
            {heading.content}
          </Heading>
        )}
        {children}
      </ul>
    );
  }
}
export default List;
